// логическое исключающее "или"
export const xor = (a: boolean, b: boolean) => (a ? !b : b);
